import { FileUploader } from 'react-drag-drop-files';
import { NONE_MENU_ID, SUPPORTED_FILE_FORMATS } from '../../common/constants';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { setName } from '../../redux/reducers/documentSlice';
import { selectDashboardLogoMetadata, selectUserIconMetadata } from '../../redux/reducers/uiSlice';
import { uploadDocument } from '../../redux/thunks';
import './header.scss';
import { selectMenu, setMenu, setSettings, setUploader } from '../../redux/reducers/popupSlice';
import { useAuth0 } from '@auth0/auth0-react';
import { getUpdatedCustomFontSize } from '../../common/util';
import { selectUserCompany, selectUserName, selectUserRole } from '../../redux/reducers/userSlice';
import { useEffect, useRef, useState } from 'react';
import { selectReadOnlyApp } from '../../redux/reducers/appSlice';
import classNames from 'classnames';
import { bulkDeleteDocument, resetAll } from '../../redux/reducers/documentsStatusSlice';
import DocStatusIcon from '../../assets/images/dashboard/header/apdt_status_btn.svg';
import FileUploadIcon from '../../assets/images/dashboard/header/apdt_upload_btn.svg';
import SiteTrackerIcon from '../../assets/images/dashboard/apst/apst_site_tracker.svg';
import KahootIcon from '../../assets/images/header/client_kahoot.svg';
import JLLIcon from '../../assets/images/header/client_jll.svg';
import UserMaleIcon from '../../assets/images/header/user_male.png';
import HeaderSeparatorIcon from '../../assets/images/header/header_separator.svg';
import APHamIcon from '../../assets/images/dashboard/apst/apst_ham_icon.svg';
import UserLandlordRepIcon from '../../assets/images/dashboard/header/User_Tenant_Rep.svg';
import UserTenantRepIcon from '../../assets/images/dashboard/header/User_Landlord_Rep.svg';
import AppLogo from '../../assets/images/dashboard/header/headerAppLogo.svg';
import UserProfileMenu from '../popup/user-profile/UserProfileMenu';
import { selectUserProfileMenuState, setSelectedClientTab, setUserProfileMenuState } from '../../redux/reducers/dashboardSlice';

const Header = () => {
  const dispatch = useAppDispatch();
  const isReadOnly = useAppSelector(selectReadOnlyApp);
  const selectedMenu = useAppSelector(selectMenu);
  const logoMetadata = useAppSelector(selectDashboardLogoMetadata);
  const userMetadata = useAppSelector(selectUserIconMetadata);
  const { user, logout } = useAuth0();
  const isUserMenuOpen = useAppSelector(selectUserProfileMenuState);
  const menuRef = useRef<HTMLDivElement>(null);
  const userRole = useAppSelector(selectUserRole);
  const clientMenuList = [
    {
      id: 'kahoot',
      clientName: 'KM',
      clientLogo: 'KahootIcon'
    },
  ];

  const [activeClientMenu, setActiveClientMenu] = useState<string>('kahoot');

  const openPopup = () => {
    dispatch(setUploader());
  };

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        dispatch(setUserProfileMenuState(false));
      }
    }
    if (isUserMenuOpen) {
      document.addEventListener('click', handleClickOutside);
    } else {
      document.removeEventListener('click', handleClickOutside);
    }
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isUserMenuOpen]);

  window.addEventListener('storage', function (event) {
    if (event.key === 'logoutEvent') {
      this.localStorage.removeItem('logoutEvent');
      logout({
        logoutParams: {
          returnTo: window.location.origin,
        },
      });
    }
  });

  const handleChange = (file: File) => {
    if (file !== undefined) {
      dispatch(setName(file.name));
      dispatch(uploadDocument(file)).then((d) => {
        openPopup();
      });
    }
  };
  const handleProfileMenu = () => {
    dispatch(setUserProfileMenuState(!isUserMenuOpen));
    dispatch(setMenu(NONE_MENU_ID));
  };
  const customStyle = {
    justifyContent: 'space-between',
    '--custom-CB-fontSize': getUpdatedCustomFontSize('--custom-CB-fontSize'),
    '--custom-upload-btn-fontSize': getUpdatedCustomFontSize('--custom-upload-btn-fontSize'),
    '--custom-user-details-fontSize': getUpdatedCustomFontSize('--custom-user-details-fontSize'),
  };
  return (
    <div className='flex-fit-basis' style={customStyle}>
      <div className='header-logo'>
        <img
          draggable="false"
          className='ab-icon cursor-default'
          src={AppLogo}
        />
        <img
          draggable="false"
          alt='Site Tracker'
          className='site-tracker-icon cursor-default'
          src={SiteTrackerIcon}
        />
      </div>
      <div className='header-separator'>
        <img src={HeaderSeparatorIcon} alt="l" />
      </div>
      <div className='header-client-menu-container'>
        <div className='header-client-menu-list'>
          {
            clientMenuList && clientMenuList?.map((menu) => (
              <div
                key={menu.id}
                className={classNames(
                  'header-client-menu-item',
                  activeClientMenu === menu.id ? 'header-client-menu-item-selected' : '',
                )}
                onClick={() => {
                  dispatch(setSelectedClientTab(menu.id));
                }}>
                <img
                  draggable="false"
                  className='header-client-menu-icon'
                  src={KahootIcon}
                />
              </div>
            ))
          }
        </div>
        <div className='header-client-menu-controls'>
          <div className='hcm-menu-list-icon'>
            <img src={APHamIcon} alt="-" />
          </div>
          <div className='hcm-menu-nav-icons'>
            <div
              className='hcm-menu-nav-icon cursor-pointer'
              onClick={() => { }}>
              {'<'}
            </div>
            <div className='hcm-menu-nav-icon cursor-pointer'
              onClick={() => { }}
            >
              {'>'}
            </div>
          </div>
        </div>
      </div>
      <div className='header-separator'>
        <img src={HeaderSeparatorIcon} alt="l" />
      </div>
      <div className='header-customer-container'>
          <img src={JLLIcon} alt="JLL" />
      </div>
      <div
        id="header-right-tools"
        className={classNames(
          'image-container',
          isReadOnly ? 'visible-hidden' : 'visibilty-not-hiddent',
        )}>
        <div
          className={classNames(
            isReadOnly ? 'visible-hidden' : 'visibilty-not-hiddent',
            'actions-container',
          )}
          onClick={handleProfileMenu}
          ref={menuRef}>
          <div className='flex user-container flex-align-center'>
            <img
              draggable="false"
              className='user-profile-image'
              src={UserMaleIcon}
            />
          </div>
        </div>
      </div>

      {isUserMenuOpen && (selectedMenu === NONE_MENU_ID || selectedMenu === '') && (
        <div className='user-profile-menu'>
          <UserProfileMenu></UserProfileMenu>
        </div>
      )}
    </div>
  );
};

export default Header;
